import { getCurrentUser } from 'nuxt-vuefire/runtime/auth/composables.js'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()

  // redirect the user to the main page
  if (!user) {
    return navigateTo({
      name: 'signin',
      query: { redirect: to.fullPath },
    })
  }
})
